import 'world-flags-sprite/stylesheets/flags32.css'
import 'v-phone-input/dist/v-phone-input.css'
import { createVPhoneInput } from 'v-phone-input'

const vPhoneInput = createVPhoneInput({
  countryIconMode: 'sprite',
  defaultCountry: 'FR',
})

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(vPhoneInput)
})
